'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'gemp_cookie_consent';
const CONSENT_EVENT = 'gemp-cookie-consent-changed';

export const CookieConsent: React.FC = () => {
    const { t } = useTranslation();
    const [isMounted, setIsMounted] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsMounted(true);
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) {
            setIsVisible(true);
        }
    }, []);

    const handleChoice = (value: 'accepted' | 'rejected') => {
        localStorage.setItem(STORAGE_KEY, value);
        window.dispatchEvent(new Event(CONSENT_EVENT));
        setIsVisible(false);
    };

    if (!isMounted || !isVisible) {
        return null;
    }

    return (
        <div className="cookie-consent" role="dialog" aria-live="polite" aria-label={t('cookieConsent.ariaLabel')}>
            <div className="cookie-consent__content">
                <div className="cookie-consent__text">
                    <h4>{t('cookieConsent.title')}</h4>
                    <p>
                        {t('cookieConsent.descriptionPrefix')}{' '}
                        <Link className="cookie-consent__link" href="/privacy-policy">
                            {t('cookieConsent.privacyPolicy')}
                        </Link>
                        {t('cookieConsent.descriptionSuffix')}
                    </p>
                </div>
                <div className="cookie-consent__actions">
                    <button
                        className="cookie-consent__button cookie-consent__button--ghost"
                        onClick={() => handleChoice('rejected')}
                        type="button"
                    >
                        {t('cookieConsent.reject')}
                    </button>
                    <button
                        className="cookie-consent__button cookie-consent__button--primary"
                        onClick={() => handleChoice('accepted')}
                        type="button"
                    >
                        {t('cookieConsent.accept')}
                    </button>
                </div>
            </div>
        </div>
    );
};
